import styled from 'styled-components/macro';

export const ErrorContainer = styled.div`
  margin: 150px auto 250px;
  max-width: 600px;
  padding: 20px;
  text-align: center;
  width: 100% !important;
`;
